import { useQuery } from "@tanstack/react-query";
import { customAxios } from "lib/axios";

export interface OrgUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
}

interface OrgUserResponse {
  success: boolean;
  data: OrgUser[];
}

const searchOrgUsers = async (
  query: string,
  limit = 10,
  signal?: AbortSignal
): Promise<OrgUser[]> => {
  const { data } = await customAxios.get<OrgUserResponse>(
    "/organizations/search/user",
    {
      params: { query, limit },
      signal,
    }
  );

  if (!data.success) {
    throw new Error("Failed to search users");
  }

  return data.data;
};

export const useSearchOrgUsers = (
  query: string,
  limit = 10,
  options?: {
    enabled?: boolean;
    staleTime?: number;
    refetchOnWindowFocus?: boolean;
  }
) =>
  useQuery<OrgUser[], Error>({
    queryKey: ["orgUsers", query, limit],
    queryFn: ({ signal }) => searchOrgUsers(query, limit, signal),
    staleTime: options?.staleTime ?? 5 * 60 * 1000,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
    enabled: !!query && (options?.enabled ?? true),
  });
